export default "__VITE_ASSET__BMintZnW__"